var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDuotone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.75C8.75 2.33579 8.41421 2 8 2C7.58579 2 7.25 2.33579 7.25 2.75V3.75H5.5C4.25736 3.75 3.25 4.75736 3.25 6V8.25H20.75V6C20.75 4.75736 19.7426 3.75 18.5 3.75H16.75V2.75C16.75 2.33579 16.4142 2 16 2C15.5858 2 15.25 2.33579 15.25 2.75V3.75H8.75V2.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 19V9.75H16.625C12.828 9.75 9.75 12.828 9.75 16.625C9.75 18.406 10.4272 20.0288 11.5382 21.25H5.5C4.25736 21.25 3.25 20.2426 3.25 19Z",
    fill: "currentColor",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 11.1245C19.601 10.2614 18.1727 9.75 16.625 9.75H20.75V11.1245Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 11.25C13.6565 11.25 11.25 13.6565 11.25 16.625C11.25 19.5935 13.6565 22 16.625 22C19.5935 22 22 19.5935 22 16.625C22 13.6565 19.5935 11.25 16.625 11.25ZM18.6553 16.2015L16.7477 18.1091C16.607 18.2498 16.4162 18.3288 16.2173 18.3288C16.0184 18.3288 15.8277 18.2498 15.687 18.1091L14.5947 17.0168C14.3018 16.7239 14.3018 16.249 14.5947 15.9562C14.8876 15.6633 15.3624 15.6633 15.6553 15.9562L16.2173 16.5182L17.5947 15.1408C17.8876 14.8479 18.3624 14.8479 18.6553 15.1408C18.9482 15.4337 18.9482 15.9086 18.6553 16.2015Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDuotone);
export default __webpack_public_path__ + "static/media/Calendar-duotone.c4775dc3127695b88292548f219a0e8a.svg";
export { ForwardRef as ReactComponent };